/* eslint-disable no-unused-vars */
import React from "react";
import "./style.scss";
import activeListData from "../../../store/activeGstNumbers.json";
import { Row, Col, Spin, Input, Form, Tooltip } from "antd";
import editButton from "../../../assests/images/penEdit.svg";
import {
  checkNumbervalue,
  checkSpecialCharacter,
  checkSpace,
} from "../../../utils";
const ServiceSummary = ({
  allAppData,
  inputHandler,
  gstEditHandler,
  gstState,
  ewayEditHandler,
  eWayState,
}) => {
  console.log(allAppData,"allAppData");
  return (
    <div className="service-summary-dox">
      <table>
        {/* left */}
        <tr>
          <td className="table-data top-left">
            <div className="heading">Type:</div>{" "}
            <div className="item">
              {allAppData?.shipmentDetails?.type
                ? allAppData?.shipmentDetails?.type
                : null}
            </div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Service :</div>{" "}
            <div className="item">{allAppData?.serviceDetails?.service}</div>{" "}
          </td>

          <td className="table-data">
            <div className="heading">Travel by :</div>{" "}
            <div className="item">{allAppData?.serviceDetails?.travelBy}</div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Content :</div>{" "}
            <div className="item">Document</div>{" "}
          </td>
          <td className="table-data gst-field bottom-left">
            <div className="heading">Sender’s GST number :</div>{" "}
            {!gstState ? (
              <div className="item-gst">
                {allAppData?.addressDetails?.senderGst
                  ? allAppData?.addressDetails?.senderGst
                  : ""}
              </div>
            ) : (
              <Form.Item
                name="senderGstNumber"
                onKeyPress={(event) => {
                  if (checkSpecialCharacter(event) || checkSpace(event)) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  () => ({
                    validator(_, value) {
                      if (
                        value.length === 15 &&
                        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
                          value
                        ) === false
                      ) {
                        return Promise.reject({
                          max: 15,
                          min: 15,
                          message: "Please enter a valid GST Number",
                        });
                      } else if (activeListData.data.includes(value)) {
                        return Promise.reject({
                          message:
                            "GST belongs to a CP. Please enter another GST number.",
                        });
                      } else if (value.length > 0 && value.length < 15) {
                        return Promise.reject({
                          message: "Please enter a valid GST Number",
                        });
                      }
                      return Promise.resolve({});
                    },
                    validateTrigger: "onSubmit",
                  }),
                ]}
              >
                <Input
                  maxLength={15}
                  defaultValue={
                    allAppData?.data?.addressDetails?.senderGst
                      ? allAppData?.data?.addressDetails?.senderGst
                      : ""
                  }
                  onChange={inputHandler}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                />
              </Form.Item>
            )}
            <Tooltip title="Edit">
              <button onClick={gstEditHandler} className="address-edit">
                <img src={editButton} />
              </button>
            </Tooltip>
          </td>
        </tr>
        {/* //right */}
        <tr>
          <td className="table-data top-right">
            <div className="heading">Description :</div>{" "}
            <div className="item">
              {allAppData?.shipmentDetails?.description || ""}
            </div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Value:</div>{" "}
            <div className="item">{allAppData?.shipmentDetails?.value}</div>{" "}
          </td>
          <td className="table-data">
            <div className="heading">Weight (Kg) :</div>{" "}
            <div className="item">{allAppData?.shipmentDetails?.weight}</div>{" "}
          </td>
          <td className="table-data eway-field">
            <div className="heading">E-Way Bill No :</div>{" "}
            {!eWayState ? (
              <div className="item-eway">
                {allAppData?.shipmentDetails?.ewayBillNumber || " "}
              </div>
            ) : (
              <Form.Item
                name="ewayBill"
                rules={[
                  () => ({
                    validator(_, value) {
                      if (value) {
                        if (parseInt(value.substring(1, 0)) === 0) {
                          return Promise.reject("E-Way Bill should not be 0");
                        } else if (value.toString().length < 12) {
                          return Promise.reject({
                            message: "Enter valid E-Way Bill",
                          });
                        }
                      }
                      return Promise.resolve({});
                    },
                    validateTrigger: "onSubmit",
                  }),
                ]}
              >
                <Input
                  maxLength={12}
                  defaultValue={
                    allAppData?.data?.shipmentDetails?.ewayBillNumber
                      ? allAppData?.data?.shipmentDetails?.ewayBillNumber
                      : ""
                  }
                  onChange={inputHandler}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                />
              </Form.Item>
            )}
            <Tooltip title="Edit">
              <button onClick={ewayEditHandler} className="address-edit">
                <img src={editButton} />
              </button>
            </Tooltip>
          </td>

          <td className="table-data">
            <div className="heading">Uploaded files :</div>{" "}
            <a className="item">{allAppData?.files?.length} attachment(s)</a>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default ServiceSummary;
